
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Customer } from '../../../../models/Customer';
import { getRegisteredCustomers, setEntraUserEnabledState } from '../../../../state/customer/customer.actions';
import { selectRegisteredCustomers } from '../../../../state/customer/customer.selector';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { RouterModule } from '@angular/router';
import { CustomerState } from '../../../../state/customer/customer.reducer';
import { PageHeaderComponent } from '../../../page-header/page-header.component';
import CustomerService from '../../../../services/CustomerService';

@Component({
  selector: 'app-manage-customers',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatButtonModule, MatIconModule, MatTooltipModule, RouterModule, PageHeaderComponent, MatSnackBarModule],
  templateUrl: './manage-customers.component.html',
  styleUrl: './manage-customers.component.css',
})
export class ManageCustomersComponent implements OnInit {
  customers$: Observable<Customer[] | null>;
  displayedColumns: string[] = ['reflexCustomerNo', 'name', 'email', 'isActive', 'actions'];

  constructor(
    private customerStore: Store<{ customer: CustomerState }>, 
    private router: Router,
    private customerService: CustomerService,
    private snackBar: MatSnackBar
  ) {
    this.customers$ = this.customerStore.select(selectRegisteredCustomers);
  }

  ngOnInit(): void {
    this.customerStore.dispatch(getRegisteredCustomers());
  }

  toggleActivation(customer: Customer): void {
    this.customerStore.dispatch(setEntraUserEnabledState({ 
      customerId: customer.id, 
      action: customer.isActive ? 'disable' : 'enable' 
    }));
  }

  goToCustomer(customer: Customer): void {
    this.router.navigate(['/admin/customers/details', customer.reflexCustomerNo]);
  }

  approveCustomer(customer: Customer): void {
    if (!customer.id) return;

    const name = customer.userDetails?.firstName && customer.userDetails?.lastName
      ? `${customer.userDetails.firstName} ${customer.userDetails.lastName}`
      : customer.userDetails?.email || 'Unbekannt';

    if (confirm(`Möchten Sie den Kunden "${name}" (${customer.reflexCustomerNo}) wirklich freischalten?`)) {
      this.customerService.approveCustomer(customer.id).subscribe({
        next: () => {
          this.snackBar.open('Kunde erfolgreich freigeschaltet!', 'OK', { duration: 3000 });
          this.customerStore.dispatch(getRegisteredCustomers()); // Refresh list
        },
        error: (error) => {
          console.error('Error approving customer:', error);
          this.snackBar.open('Fehler beim Freischalten des Kunden', 'OK', { duration: 3000 });
        }
      });
    }
  }

  rejectCustomer(customer: Customer): void {
    if (!customer.id) return;

    const name = customer.userDetails?.firstName && customer.userDetails?.lastName
      ? `${customer.userDetails.firstName} ${customer.userDetails.lastName}`
      : customer.userDetails?.email || 'Unbekannt';

    if (confirm(`Möchten Sie den Kunden "${name}" (${customer.reflexCustomerNo}) wirklich ablehnen?`)) {
      this.customerService.rejectCustomer(customer.id).subscribe({
        next: () => {
          this.snackBar.open('Kunde wurde abgelehnt', 'OK', { duration: 3000 });
          this.customerStore.dispatch(getRegisteredCustomers()); // Refresh list
        },
        error: (error) => {
          console.error('Error rejecting customer:', error);
          this.snackBar.open('Fehler beim Ablehnen des Kunden', 'OK', { duration: 3000 });
        }
      });
    }
  }
}
